import { Loader } from "@googlemaps/js-api-loader";

/**
 * Does stuff
 * @param {String} selector - selector for map container or null to use $el
 * @param {Object} center - Object containing lat and lng key/value pairs
 * @param {Object} opts - Map config
 * @param {Array} markerData - Array of markers
 */

export default ((apiKey = "", selector = null, center, opts = {}, markerData = []) => ({
	defaultOptions: {
		zoom: 10,
		clickableIcons: false,
		disableDefaultUI: true,
		panControl: true,
		zoomControl: true,
		streetViewControl: false,
		overviewMapControl: false,
		scrollwheel: true,
		navigationControl: false,
		mapTypeControl: false,
		scaleControl: false,
		draggable: true,
		rotateControl: false,
		styles: [{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"visibility":"on"}]},{"featureType":"administrative","elementType":"labels","stylers":[{"visibility":"on"},{"color":"#716464"},{"weight":"0.01"}]},{"featureType":"administrative.country","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"landscape","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"simplified"}]},{"featureType":"poi","elementType":"geometry.stroke","stylers":[{"visibility":"simplified"}]},{"featureType":"poi","elementType":"labels.text","stylers":[{"visibility":"simplified"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"visibility":"simplified"}]},{"featureType":"poi","elementType":"labels.text.stroke","stylers":[{"visibility":"simplified"}]},{"featureType":"poi.attraction","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"simplified"},{"color":"#a05519"},{"saturation":"-13"}]},{"featureType":"road.local","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"simplified"},{"color":"#84afa3"},{"lightness":52}]},{"featureType":"water","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"visibility":"on"}]}]
	},
	map: null,
	markerData: [],
	markers: [],
	options: {},

	init() {
		this.options = {
			...this.defaultOptions,
			center,
		}

		this.options = {
			...this.options,
			...opts,
		}

		const el = selector ? this.$el.querySelector(selector) : this.$el;

		this.markerData = markerData.length ? JSON.parse(markerData) : [];

		const loader = new Loader({
			apiKey,
			version: "weekly",
		});

		loader.load().then(async () => {
			const { Map } = await google.maps.importLibrary("maps");

			this.map = new Map(el, {
				...this.options,
			});

			if(markerData.length) this.addMarkers();

			google.maps.event.addListener(this.map, "click", () => {
				if (this.map.currInfoWindow) this.map.currInfoWindow.close();
			})
		});
	},

	addMarker(infoContent, markerPosition, markerId = null, county = null) {
		//const markerSvg = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='46' height='46'%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='none' d='M0 0h21.804v20.649H0z' data-name='Rectangle 32'/%3E%3C/clipPath%3E%3C/defs%3E%3Cg data-name='Group 600' transform='translate(-62 -504)'%3E%3Ccircle cx='23' cy='23' r='23' fill='%23fff' data-name='Ellipse 13' transform='translate(62 504)'/%3E%3Cg data-name='Group 575'%3E%3Cg clip-path='url(%23a)' data-name='Group 574' transform='translate(73.25 517.176)'%3E%3Cpath fill='%23028844' d='M17.273 6.007a12.114 12.114 0 0 0-9.534-4.283h-.157l.141-.069a12.559 12.559 0 0 1 12.72.921l.051.036-.057.025a5.602 5.602 0 0 0-.39.189 5.717 5.717 0 0 0-2.714 3.169l-.02.058Z' data-name='Path 576'/%3E%3Cpath fill='%23e22922' d='M5.219 12.436a5.715 5.715 0 0 0-4.144.478 5.36 5.36 0 0 0-.374.218l-.052.033v-.062a12.558 12.558 0 0 1 6.349-11.06l.136-.078-.09.129a12.113 12.113 0 0 0-1.78 10.3l.017.059Z' data-name='Path 577'/%3E%3Cpath fill='%230076d6' d='M11.386 10.208a6.418 6.418 0 0 0-3.184.51 6.447 6.447 0 0 0-.466.225 6.377 6.377 0 0 0-1.749 1.362l-.041.045-.018-.058A12.174 12.174 0 0 1 7.297 2.023l.033-.052 4.119 8.244Z' data-name='Path 578'/%3E%3Cpath fill='%23ffd500' d='M7.476 1.894h.062a12.175 12.175 0 0 1 9.279 4.607l.038.048-.06.009a6.375 6.375 0 0 0-2.107.689 7.2 7.2 0 0 0-.447.26 6.42 6.42 0 0 0-2.2 2.355l-.03.056Z' data-name='Path 579'/%3E%3Cpath d='M21.215 2.327a13.257 13.257 0 0 0-13.742-.782L6.622.243a.1.1 0 0 0-.136-.035.1.1 0 0 0-.047.132l.6 1.434A13.257 13.257 0 0 0 .006 13.6q.012.372.049.744a5.165 5.165 0 0 1 5.319-1.3l.066.022q.244.084.481.193.124-.181.261-.352c.031-.039.062-.078.094-.115a5.839 5.839 0 0 1 1.712-1.372q.209-.111.429-.207a5.827 5.827 0 0 1 3.3-.415l4.786 9a1.6 1.6 0 0 0 .776.715 1.619 1.619 0 0 0 .8.126 1.6 1.6 0 0 0 1.252-2.347l-.28-.526a.349.349 0 0 0-.616.328l.28.526a.905.905 0 0 1-1.3 1.181h-.005l-.047-.034a1.478 1.478 0 0 1-.293-.374l-4.744-8.921a5.827 5.827 0 0 1 2.192-2.508q.2-.129.411-.24a5.838 5.838 0 0 1 2.1-.652l.148-.013q.218-.019.438-.02.042-.257.109-.507l.019-.067a5.149 5.149 0 0 1 4.058-3.682q-.288-.237-.589-.456M5.228 12.4a5.749 5.749 0 0 0-4.546.7A12.535 12.535 0 0 1 7.013 2.073 12.213 12.213 0 0 0 5.228 12.4m6.163-2.227Zm-.1-.193.1.192a6.52 6.52 0 0 0-5.43 2.11 12.181 12.181 0 0 1 1.366-10.24Zm.872.909Zm2.058-3.41a6.426 6.426 0 0 0-2.22 2.368l-.1-.187-4.365-7.729a12.181 12.181 0 0 1 9.253 4.593 6.465 6.465 0 0 0-2.568.954m4.717-3.928a5.709 5.709 0 0 0-1.637 2.434 12.212 12.212 0 0 0-9.562-4.3 12.534 12.534 0 0 1 12.684.918 5.74 5.74 0 0 0-1.483.943' data-name='Path 580'/%3E%3Cpath d='M11.39 10.174Z' data-name='Path 581'/%3E%3Cpath d='M11.391 10.176Z' data-name='Path 582'/%3E%3Cpath d='M12.166 10.891' data-name='Line 20'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E";
    const markerSvg = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='82' height='84' fill='none'%3E%3Ccircle cx='41' cy='43' r='41' fill='%23000' fill-opacity='.5'/%3E%3Ccircle cx='41' cy='41' r='39.5' fill='%23757575' stroke='%23fff' stroke-width='3'/%3E%3Cpath fill='%23fff' d='M57.29 49.353c-.78-2.223-2.595-3.349-4.349-4.438-1.525-.948-2.966-1.844-3.908-3.453-2.597-4.456-4.023-7.145-8.278-7.145-4.254 0-5.685 2.69-8.288 7.144-.943 1.613-2.39 2.51-3.918 3.46-1.753 1.09-3.566 2.214-4.347 4.432-.305.8-.458 1.649-.452 2.505 0 3.607 2.873 6.542 6.056 6.542s7.377-1.605 10.958-1.605c3.582 0 7.717 1.605 10.94 1.605 3.222 0 6.046-2.935 6.046-6.542a6.934 6.934 0 0 0-.46-2.505ZM24.458 42.817c2.739 0 4.959-2.855 4.959-6.375 0-3.521-2.22-6.375-4.959-6.375-2.738 0-4.958 2.854-4.958 6.375 0 3.52 2.22 6.375 4.958 6.375ZM34.375 34.317c2.738 0 4.958-2.855 4.958-6.375 0-3.521-2.22-6.375-4.958-6.375s-4.958 2.854-4.958 6.375c0 3.52 2.22 6.375 4.958 6.375ZM47.125 34.317c2.738 0 4.958-2.855 4.958-6.375 0-3.521-2.22-6.375-4.958-6.375-2.739 0-4.958 2.854-4.958 6.375 0 3.52 2.22 6.375 4.958 6.375ZM57.042 42.817c2.738 0 4.958-2.855 4.958-6.375 0-3.521-2.22-6.375-4.958-6.375-2.739 0-4.959 2.854-4.959 6.375 0 3.52 2.22 6.375 4.959 6.375Z'/%3E%3C/svg%3E";

		let marker = new google.maps.Marker({
			position: markerPosition,
			map: this.map,
			icon: {
				url: markerSvg,
				scaledSize: new google.maps.Size(41, 42),
				anchor: new google.maps.Point(20.5, 21),
			}
		});

		let info;

		if(infoContent) {
			this.map.currInfoWindow = false;

			info = new google.maps.InfoWindow({
				content: infoContent,
				pixelOffset: new google.maps.Size(0, -10),
			});

			google.maps.event.addListener(marker, 'click', () => {
				if (this.map.currInfoWindow) this.map.currInfoWindow.close();
				info.open(this.map, marker);
				this.map.currInfoWindow = info;

				if(markerId) {
					this.$dispatch('gmap-marker-open', { uid: markerId });
				}
			});
		}

		this.markers.push({
			marker: marker,
			id: markerId,
			...(infoContent && { info: info }),
			county: county,
		})
	},

	openMarkerByID(id) {
		const marker = this.markers.find(marker => {
			return marker.id === id;
		})

		if(marker) {
			if (this.map.currInfoWindow) this.map.currInfoWindow.close();
			marker.info.open(this.map, marker.marker);
			this.map.currInfoWindow = marker.info;
		}
	},

	setMarkerHoverByID(id) {
		const marker = this.markers.find(marker => {
			return marker.id === id;
		})

		if(marker) {
			marker.marker.setAnimation(google.maps.Animation.BOUNCE);
		}
	},

	unsetMarkerHoverByID(id) {
		const marker = this.markers.find(marker => {
			return marker.id === id;
		})

		if(marker) {
			marker.marker.setAnimation(null);
		}
	},

	addMarkers() {
		for(const marker in this.markerData) {
			let m = this.markerData[marker];
			let latLong = m.latLong.split(",");
			this.addMarker(
				m.html,
				{
					lat: +latLong[0],
					lng: +latLong[1],
				},
				m.id || null,
				m.county || null,
			)
		}
	},

	filterMarkers(filter) {
		this.markers.forEach(marker => {
			if (filter(marker)) {
				marker.marker.setVisible(true);
			} else {
				marker.marker.setVisible(false);
			}
		});
	}
}));
